export class Gui
{
    constructor( appInstance )
    {
        this.app = appInstance;
        this.snackbarError = new bootstrap.Toast( document.getElementById( 'snackbar-error' ) );
        this.snackbarConfirmed = new bootstrap.Toast( document.getElementById( 'snackbar-confirmed' ) );

    }

    getGenericModalContainer()
    {
        return document.querySelector( '[data-id="modal-generic"]' );
    }

    showGenericModal( content )
    {
        const container = this.getGenericModalContainer();
        container.innerHTML = content;
        container.classList.add( 'menu-active' );
        document.querySelector( '[data-id="static-backdrop"]' ).classList.add( 'static-hider-active' );
    }

    closeGenericModal()
    {
        const container = this.getGenericModalContainer();
        container.classList.remove( 'menu-active' );
        document.querySelector( '[data-id="static-backdrop"]' ).classList.remove( 'static-hider-active' );
    }

    getGenericConfirmModalContainer()
    {
        return document.querySelector( '[data-id="modal-confirm-generic"]' );
    }

    showGenericConfirmModal( txtConfirm, fnConfirmCallback )
    {
        const container = this.getGenericConfirmModalContainer();
        container.querySelector( '[data-id="txtConfirmation"]' ).innerHTML = txtConfirm;
        container.classList.add( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.add( 'menu-active' );
        container.querySelector( '[data-id="btnCancel"]' ).addEventListener( 'click', () => {
            this.hideGenericConfirmModal();
        });
        container.querySelector( '[data-id="btnConfirm"]' ).addEventListener( 'click', () => {
            this.hideGenericConfirmModal();
            fnConfirmCallback && fnConfirmCallback();
        });
    }

    hideGenericConfirmModal()
    {
        const container = this.getGenericConfirmModalContainer();
        container.querySelector( '[data-id="btnCancel"]' ).removeEventListeners( 'click' );
        container.querySelector( '[data-id="btnConfirm"]' ).removeEventListeners( 'click' );
        container.classList.remove( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.remove( 'menu-active' );
    }

    getDynamicRoutineModalContainer()
    {
        return document.querySelector( '[data-id="menu-dynamic-selection"]' );
    }

    showDynamicRoutineModalContainer( selection )
    {
        this.getDynamicRoutineModalContainer().querySelector( '[data-id="menu-dynamic-selection-content"]' ).innerHTML = selection;
        document.querySelector( '[data-id="menu-dynamic-selection"]' ).classList.add( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.add( 'menu-active' );
    }

    hideDynamicRoutineModalContainer()
    {
        document.querySelector( '[data-id="menu-dynamic-selection"]' ).classList.remove( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.remove( 'menu-active' );
    }

    getIndividualItemModalContainer()
    {
        return document.querySelector( '[data-id="menu-individual-item-selection"]' );
    }

    showIndividualItemModalContainer()
    {
        document.querySelector( '[data-id="menu-individual-item-selection"]' ).classList.add( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.add( 'menu-active' );
    }

    hideIndividualItemModalContainer()
    {
        document.querySelector( '[data-id="menu-individual-item-selection"]' ).classList.remove( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.remove( 'menu-active' );
    }

    getWeeklyFrequenceModalContainer()
    {
        return document.querySelector( '[data-id="menu-frequence-selection"]' );
    }

    showFrequenceModal( frequencies )
    {
        document.querySelector( '[data-id="menu-frequence-selection"]' ).classList.add( 'menu-active' );
        document.querySelector( '[data-id="menu-backdrop"]' ).classList.add( 'menu-active' );
    }

    hideFrequenceModal()
    {
        const activeMenu = document.querySelectorAll('.menu-active');
        for(let i=0; i < activeMenu.length; i++){activeMenu[i].classList.remove('menu-active');}
    }

    showSnackbarError( message )
    {
        const snackbar = document.getElementById( 'snackbar-error' );
        if ( snackbar )
        {
            snackbar.querySelector( '[data-id="message"]' ).innerHTML = message;
            this.snackbarError.show();
        }
    }

    showSnackbarConfirmed( message )
    {
        const snackbar = document.getElementById( 'snackbar-confirmed' );
        if ( snackbar )
        {
            snackbar.querySelector( '[data-id="message"]' ).innerHTML = message;
            this.snackbarConfirmed.show();
        }
    }

    showPageLoader( msg = '' )
    {
        const container = document.querySelector( '[data-id="inapp-page-loader"]' );
        container.querySelector( '[data-id="preloading-text"]' ).innerHTML = msg;
        container.style.display = 'block';
    }

    hidePageLoader()
    {
        const container = document.querySelector( '[data-id="inapp-page-loader"]' );
        container.style.display = 'none';
    }

    showLoader( msg = null, isTransparent = false )
    {
        const preloader = document.querySelector( '[data-id="preloader"]' );
        if ( preloader )
        {
            let msgDisplayed = false;
            if ( msg && msg.length > 0 )
            {
                const txt = preloader.querySelector( '[data-id="preloading-text"]' );
                if ( txt )
                {
                    txt.innerHTML = msg;
                    msgDisplayed = true;
                }
            }
            if ( false === msgDisplayed )
            {
                const txt = preloader.querySelector( '[data-id="preloading-text"]' );
                if ( txt )
                {
                    txt.innerHTML = '';
                }
            }

            if ( true === isTransparent )
            {
                preloader.classList.add( 'preloader-show-transparent' );
            }
            else
            {
                preloader.classList.add( 'preloader-show' );
            }
            preloader.classList.remove( 'preloader-hide' );
        }
    }

    hideLoader()
    {
        const preloader = document.querySelector( '[data-id="preloader"]' );
        if ( preloader )
        {
            preloader.classList.remove( 'preloader-show' );
            preloader.classList.remove( 'preloader-show-transparent' );
            preloader.classList.add( 'preloader-hide' );
        }
    }

    addFormValidators( formElement )
    {
        var inputField = formElement.querySelectorAll('input');
        if(inputField.length){
            var mailValidator = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;
            var phoneValidator = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
            var nameValidator = /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/u;
            var passwordValidator = /[A-Za-z]{2}[A-Za-z]*[ ]?[A-Za-z]*/;
            var numberValidator = /^(0|[1-9]\d*)$/;
            var linkValidator = /^(http|https)?:\/\/[a-zA-Z0-9-\.]+\.[a-z]{2,4}/;
            var textValidator = /[A-Za-z]{2}[A-Za-z]*[ ]?[A-Za-z]*/;

            function valid(el){
                el.parentElement.querySelectorAll('.valid')[0].classList.remove('disabled');
                el.parentElement.querySelectorAll('.invalid')[0].classList.add('disabled');
            }
            function invalid(el){
                el.parentElement.querySelectorAll('.valid')[0].classList.add('disabled');
                el.parentElement.querySelectorAll('.invalid')[0].classList.remove('disabled');
            }
            function unfilled(el){
                el.parentElement.querySelectorAll('em')[0].classList.remove('disabled');
                el.parentElement.querySelectorAll('.valid')[0].classList.add('disabled');
                el.parentElement.querySelectorAll('.invalid')[0].classList.add('disabled');
            }

            var regularField = document.querySelectorAll('.input-style input:not([type="date"])')
            regularField.forEach(el => el.addEventListener('keyup', e => {
                if(!el.value == ""){
                    el.parentElement.classList.add('input-style-active');
                    el.parentElement.querySelector('em').classList.add('disabled');
                } else {
                    el.parentElement.querySelectorAll('.valid')[0].classList.add('disabled');
                    el.parentElement.querySelectorAll('.invalid')[0].classList.add('disabled');
                    el.parentElement.classList.remove('input-style-active');
                    el.parentElement.querySelector('em').classList.remove('disabled');
                }
            }));

            var regularTextarea = document.querySelectorAll('.input-style textarea')
            regularTextarea.forEach(el => el.addEventListener('keyup', e => {
                if(!el.value == ""){
                    el.parentElement.classList.add('input-style-active');
                    el.parentElement.querySelector('em').classList.add('disabled');
                } else {
                    el.parentElement.classList.remove('input-style-active');
                    el.parentElement.querySelector('em').classList.remove('disabled');
                }
            }));

            var selectField = document.querySelectorAll('.input-style select')
            selectField.forEach(el => el.addEventListener('change', e => {
                if(el.value !== "default"){
                    el.parentElement.classList.add('input-style-active');
                    el.parentElement.querySelectorAll('.valid')[0].classList.remove('disabled');
                    el.parentElement.querySelectorAll('.invalid, em, span')[0].classList.add('disabled');
                }
                if(el.value == "default"){
                    el.parentElement.querySelectorAll('span, .valid, em')[0].classList.add('disabled');
                    el.parentElement.querySelectorAll('.invalid')[0].classList.remove('disabled');
                    el.parentElement.classList.add('input-style-active');
                }
            }));

            var dateField = document.querySelectorAll('.input-style input[type="date"]')
            dateField.forEach(el => el.addEventListener('change', e => {
                el.parentElement.classList.add('input-style-active');
                el.parentElement.querySelectorAll('.valid')[0].classList.remove('disabled');
                el.parentElement.querySelectorAll('.invalid')[0].classList.add('disabled');
            }));

            var validateField = document.querySelectorAll('.validate-field input, .validator-field textarea');
            if(validateField.length){
                validateField.forEach(el => el.addEventListener('keyup', e => {
                    var getAttribute = el.getAttribute('type');
                    switch(getAttribute){
                        case 'name': nameValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'number': numberValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'email': mailValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'text': textValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'url': linkValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'tel': phoneValidator.test(el.value) ? valid(el) : invalid(el); break;
                        case 'password': passwordValidator.test(el.value) ? valid(el) : invalid(el); break;
                    }
                    if(el.value === ""){unfilled(el);}
                }));
            }
        }
    }

    removeFormValidators( formElement )
    {
        formElement.removeEventListeners();
    }
}
